export const createFetchRequest = (url: string, sessionId: string, method: "GET" | "POST" | "PUT" | "DELETE" = "GET", body?: any): Promise<Response> => {
    return fetch( `index.php?uri=${url}`, {
        method,
        headers: {
            'x-api-key': sessionId
        },
        body
    });
};